import { useIntl } from 'react-intl'
import { News as INews } from '@models/news'
import TabBar from '@components/UI/TabBar/TabBar'
import NewsItem from '../../containers/NewsItem'
import { isMobileChecker } from '@/app/utils/commonFunctions'
import { LuxIconSpinner } from '@lux/wardrobe-lib'

const News = (props: any) => {
    const {
        newsList,
        loading,
        activities,
        activeTab,
        tabBarConfiguration,
        showContent,
        hideSidebar,
        tabBarHandler,
    } = props

    const intl = useIntl()

    const newsClass = 'home-news'

    const isMobile = isMobileChecker()

    const tabBarConfigurationLocalized = tabBarConfiguration.map((tab) => ({
        ...tab,
        keyName: intl.formatMessage({
            id: tab.keyName,
            defaultMessage: tab.name,
        }),
    }))

    return (
        <div
            className={`${newsClass}${hideSidebar ? ' hideSidebar' : ''}`}
            style={{
                marginTop: isMobile ? 0 : showContent ? (activities?.length > 0 ? 221 : 120) : 80,
                height: isMobile
                    ? 'auto'
                    : `calc( 100vh - ${
                          showContent ? (activities?.length > 0 ? 221 : 120) : 80
                      }px - var(--smart-navbar-height) )`,
            }}>
            <div className={`${newsClass}__tab-bar-container`}>
                <TabBar
                    activeTab={activeTab}
                    onClick={tabBarHandler}
                    tabs={tabBarConfigurationLocalized}
                />
            </div>
            <div
                className={`${newsClass}__list-container`}
                style={{ paddingTop: isMobile ? 0 : 81.59 }}>
                {newsList?.map((n: INews, i: number) => (
                    <div className={`${newsClass}__item-container`} key={i}>
                        <NewsItem news={n} reactions={n.reactions} commentsList={n.commentsList} />
                    </div>
                ))}
                {loading && <LuxIconSpinner />}
                {!loading && newsList?.length === 0 && (
                    <div className={`${newsClass}__no-news`}>
                        {intl.formatMessage({
                            id: 'home.activities.alert.no_news',
                            defaultMessage: 'No news.',
                        })}
                    </div>
                )}
            </div>
        </div>
    )
}

export default News
